/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

const Video = ({ videoSrcURL }) => (
  <span className="video">
    <video autoPlay muted loop width="100%">
      <source src={`/videos/${videoSrcURL}.mov`} type="video/mov" />
      <source src={`/videos/${videoSrcURL}.webm`} type="video/webm" />
      <source src={`/videos/${videoSrcURL}.mp4`} type="video/mp4" />
      Your browser is not supported!
    </video>
  </span>
);
export default Video;
